import { Howl } from 'howler';

export class Player {
    constructor(element) {
        this.howler = null;
        this.element = element;
        this.button = null;

        this.url = null;
        this.seek = 0;
        this.seeking = false;
        this.timeInterval = null;
        this.actualTime = 0;
        this.isLoading = true;
        this.isPlaying = false;
        this.collapsed = true;
        this.muted = false;
        this.volume = localStorage.getItem('volume') == null ? 0.5 : localStorage.getItem('volume') / 100;

        this.seekColor = $("body").hasClass("c-dark-theme") ? Utils.getColor("success-dark-theme") : Utils.getColor("success");
        this.volumeColor = "#FFF";

        this.render();

        document.addEventListener('click', (e) => {
            if(this.button != null && (e.target == this.button || e.target.parentNode == this.button)) {
                this.play();
                return;
            }

            if(e.target.matches('.play-audio-button')) {
                this.button = e.target;
                this.openPlayer(this.button.dataset.name, this.button.dataset.url);
            } else if(e.target.parentNode.matches('.play-audio-button')) {
                this.button = e.target.parentNode;
                this.openPlayer(this.button.dataset.name, this.button.dataset.url);
            }
        });
    }

    openPlayer(name, url) {
        this.element.querySelector('#audioPlayer').classList.remove('d-none');
        if(this.collapsed) {
            this.collapse();
        }

        this.element.querySelector('.track-name').innerHTML = name;
        this.url = url;

        if(this.howler != null) {
            document.querySelectorAll('.play-audio-button').forEach((button) => {
                if(button.matches('i')) {
                    button.classList.remove('cil-media-pause');
                    button.classList.add('cil-media-play');
                } else {
                    let btn = button.querySelector('.cil-media-pause');
                    if(btn != null) {
                        btn.classList.add('cil-media-play');
                        btn.classList.remove('cil-media-pause');
                    }
                }
            });
            this.howler.unload();
            this.howler = null;
        }

        this.setupHowler();
    }

    render() {
        this.element.innerHTML = `
        <div id="audioPlayer" class="d-none">
            <div class="audioCollapseButton">
                <i class="c-icon-custom-size c-icon-middle cil-chevron-top-alt d-none"></i>
                <i class="c-icon-custom-size c-icon-middle cil-chevron-bottom-alt"></i>
            </div>
            <div class="collapse" id="collapseAudioPlayer">
                <div class="container">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="row">
                                <div class="col-8">
                                    <div class="volume">
                                        <div class="volume-icon">
                                            <i class="c-icon-custom-size c-icon-middle cil-volume-off d-none"></i>
                                            <i class="c-icon-custom-size c-icon-middle cil-volume"></i>
                                        </div>
                                        <div class="volume-container">
                                            <input id="volume-obj" type="range" name="vol" min="0" step="0.25" value="50" class="volume-slider">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="play">
                                        <div class="play-btn">
                                            <div class="spinner-border" role="status">
                                                <span class="sr-only">Loading...</span>
                                            </div>
                                            <i class="c-icon-custom-size c-icon-middle cil-media-pause d-none"></i>
                                            <i class="c-icon-custom-size c-icon-middle cil-media-play d-none"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-8">
                            <div class="player-controls scrubber">
                                <div class="float-left track-name">Undefined</div>
                                <div class="time-container">
                                    <input id="seek-obj" type="range" name="seek" min="0" step="0.25" value="0" class="seek">
                                </div>
                                <div class="time float-left"></div>
                                <div class="time float-right"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        `;

        this.setVolumeSlider(this.volume * 100);

        // Add event listeners
        this.element.querySelector('.audioCollapseButton').addEventListener('click', () => this.collapse());

        this.element.querySelector('.play').addEventListener('click', () => this.play());
        this.element.querySelector('.cil-volume-off').addEventListener('click', () => this.muteVolume());
        this.element.querySelector('.cil-volume').addEventListener('click', () => this.muteVolume());
        this.element.querySelector('#seek-obj').addEventListener('input', () => this.seekToPos(this.element.querySelector('#seek-obj').value));
        this.element.querySelector('#volume-obj').addEventListener('input', () => this.setVolume(this.element.querySelector('#volume-obj').value));
    }

    setupHowler() {
        this.howler = new Howl({
            src: this.url,
            autoplay: true,
            loop: false,
            volume: this.volume,
            html5: true,
            preload: true,
            onload: () => {
                this.isLoading = false;
                this.isPlaying = true;
                this.element.querySelector('.spinner-border').classList.add('d-none');
                this.setPlayButton();
                this.totalTime = this.howler.duration();
            },
            onend: () => {
                this.isPlaying = false;
                this.setPlayButton();
            },
            onpause: () => {
                this.isPlaying = false;
                this.setPlayButton();
            },
            onstop: () => {
                this.isPlaying = false;
                this.setPlayButton();
            },
            onplay: () => {
                this.isPlaying = true;
                this.setPlayButton();
            },
            onloaderror: () => {
                this.isLoading = false;
                this.isPlaying = false;
                this.setPlayButton();
                this.destroy();
            }
        });

        this.timeInterval = setInterval(() => {
            if(!this.seeking) {
                this.seek = this.howler.seek() / (this.howler.duration() / 100);
                this.actualTime = this.howler == null ? 0 : this.howler.seek();
                this.totalTime = this.howler.duration() - this.howler.seek();

                if(!isNaN(this.seek)) {
                    this.element.querySelector("#seek-obj").value = this.seek;
                }

                this.element.querySelector('.time.float-left').innerHTML = this.fancyTimeFormat(this.actualTime);
                this.element.querySelector('.time.float-right').innerHTML = this.fancyTimeFormat(this.totalTime);
                this.setSeekColor('#seek-obj', this.seek, this.seekColor);
            }
        }, 100);
    }

    seekToPos(seek) {
        this.seek = seek;
        this.howler.seek(this.howler.duration() * (seek/100));
    }

    destroy() {
        clearInterval(this.timeInterval);
        if(this.howler != null) {
            this.howler.unload();
        }
    }

    play() {
        if(this.isPlaying) {
            this.howler.pause();
        } else {
            this.howler.play();
        }

        this.isPlaying = !this.isPlaying;

        this.setPlayButton();
    }

    setSeekColor(element, seek, color) {
        try {
            var percent = seek;
            var seekObj = document.querySelector(element);
            var linearGradientWebkit = "-webkit-gradient(linear, left top, right top, color-stop(" + percent + "%, " + color + "), color-stop(" + percent + "%, rgb(85,85,85)))";
            var linearGradientMoz = "-moz-linear-gradient(left center, " + color + " 0%, " + color + " " + percent + "%, rgb(85,85,85) " + percent + "%, rgb(85,85,85) 100%)";

            seekObj.style.backgroundImage = linearGradientWebkit;
            seekObj.style.backgroundImage = linearGradientMoz;
        } catch (e) {}
    }

    setVolume(percentage) {
        this.volume = percentage / 100;
        this.muted = (percentage == 0);

        this.howler.volume(percentage / 100);

        localStorage.setItem('volume', percentage);

        this.setVolumeSlider(percentage);
    }

    setVolumeSlider(percentage) {
        if(percentage == 0) {
            this.element.querySelector('#volume-obj').value = 0;
            this.setSeekColor('#volume-obj', 0, this.volumeColor);
            this.element.querySelector('.cil-volume-off').classList.remove('d-none');
            this.element.querySelector('.cil-volume').classList.add('d-none');
        } else {
            this.element.querySelector('#volume-obj').value = percentage;
            this.setSeekColor('#volume-obj', percentage, this.volumeColor);
            this.element.querySelector('.cil-volume-off').classList.add('d-none');
            this.element.querySelector('.cil-volume').classList.remove('d-none');
        }
    }

    setPlayButton() {
        if(this.isPlaying) {
            this.element.querySelector('.cil-media-pause').classList.remove('d-none');
            this.element.querySelector('.cil-media-play').classList.add('d-none');

            if(this.button != null) {
                if(this.button.matches('i')) {
                    this.button.classList.remove('cil-media-play');
                    this.button.classList.add('cil-media-pause');
                } else {
                    let button = this.button.querySelector('.cil-media-play');
                    if(button != null) {
                        button.classList.add('cil-media-pause');
                        button.classList.remove('cil-media-play');
                    }
                }
            }
        } else {
            this.element.querySelector('.cil-media-play').classList.remove('d-none');
            this.element.querySelector('.cil-media-pause').classList.add('d-none');

            if(this.button != null) {
                if(this.button.matches('i')) {
                    this.button.classList.remove('cil-media-pause');
                    this.button.classList.add('cil-media-play');
                } else {
                    let button = this.button.querySelector('.cil-media-pause');
                    if(button != null) {
                        button.classList.add('cil-media-play');
                        button.classList.remove('cil-media-pause');
                    }
                }
            }
        }
    }

    collapse() {
        if(this.collapsed) {
            this.element.querySelector('.cil-chevron-top-alt').classList.add('d-none');
            this.element.querySelector('.cil-chevron-bottom-alt').classList.remove('d-none');
            // let collapse = this.element.querySelector("#collapseAudioPlayer");
            // setTimeout(() => {
            //     collapse.classList.remove('collapsing');
            //     collapse.classList.add('collapse');
            // }, 350);
            // collapse.classList.remove('collapse');
            // collapse.classList.add('collapsing');
            // collapse.classList.add('show');

            $("#collapseAudioPlayer").collapse('show');
        } else {
            this.element.querySelector('.cil-chevron-top-alt').classList.remove('d-none');
            this.element.querySelector('.cil-chevron-bottom-alt').classList.add('d-none');
            $("#collapseAudioPlayer").collapse('hide');
        }

        this.collapsed = !this.collapsed;
    }

    muteVolume() {
        if(this.muted) {
            if(this.volume == 0) {
                this.volume = 0.5;
            }

            this.howler.volume(this.volume);
            localStorage.setItem('volume', this.volume * 100);
            this.setVolumeSlider(this.volume * 100);
        } else {
            this.volume = this.howler.volume();
            this.howler.volume(0);
            localStorage.setItem('volume', 0);
            this.setVolumeSlider(0);
        }

        this.muted = !this.muted;
    }

    handleLoad(node) {
        if (this.howler.duration() > 0) {
            try {
                const bufferedAmount = Math.floor(node.buffered.end(node.buffered.length - 1));
                this.element.querySelector(".time-container").style.setProperty('--buffered-width', `${(bufferedAmount / this.howler.duration()) * 100}%`);
            } catch($e) {

            }
        }
    }

    fancyTimeFormat(duration) {
        var hrs = ~~(duration / 3600);
        var mins = ~~((duration % 3600) / 60);
        var secs = ~~duration % 60;

        var ret = "";

        if (hrs > 0) {
            ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
        }

        ret += "" + mins + ":" + (secs < 10 ? "0" : "");
        ret += "" + secs;
        return ret;
    }
}
